import { connect } from 'react-redux'
import { GameMenu } from '../components'

const mapStateToProps = (state, ownProps) => {
  const { width } = state.window
  const { user } = state.authentication
  return ({
    width,
    user,
  })
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return ({
  })
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(GameMenu)


// WEBPACK FOOTER //
// ./src/Pages/Game/containers/GameMenu.js